import {useLayoutEffect, useState} from "react";
import useResizeObserver from "@react-hook/resize-observer";

const useElementSize = (target: any) => {
    const [size, setSize] = useState<DOMRectReadOnly>();

    useLayoutEffect(() => {
        setSize(target.current.getBoundingClientRect())
    }, [target]);

    useResizeObserver(target, (entry) => setSize(entry.contentRect));

    return size
}

export default useElementSize;